import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, switchMap } from 'rxjs';
import { HttpError, HttpResponse } from '@shared/utils/models/http.model';
import { PublicEventService } from '../services/public-event.service';
import { PublicEventActions, PublicEventResetActions } from '../actions/public-event.actions';
import { EventRegisterResponse, PublicEventDetails } from '@features/public-event/utils/models/public-event.model';

@Injectable()
export class PublicEventEffects {
  private readonly publicEventService = inject(PublicEventService);
  private readonly actions$ = inject(Actions);

  getEventDetails$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PublicEventActions.getPublicEvent, PublicEventResetActions.cancelPublicEventActions),
      switchMap((action) =>
        action.type === PublicEventResetActions.cancelPublicEventActions.type
          ? of(PublicEventResetActions.cancelPublicEventActionsSuccess())
          : this.publicEventService.getEventDetails(action.hash, action.userId).pipe(
              map((response: HttpResponse<PublicEventDetails>) =>
                PublicEventActions.getPublicEventSuccess({ event: response.message })
              ),
              catchError((error: HttpError) => of(PublicEventActions.getPublicEventFailure({ error })))
            )
      )
    );
  });

  recordViewEvent$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PublicEventActions.recordViewEvent),
      mergeMap((action) =>
        this.publicEventService.recordViewEvent(action.eventId).pipe(
          map(() => PublicEventActions.recordViewEventSuccess()),
          catchError((error: HttpError) => of(PublicEventActions.recordViewEventFailure({ error })))
        )
      )
    );
  });

  eventRegister$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PublicEventActions.registerForEvent),
      mergeMap((action) =>
        this.publicEventService.registerForEvent(action.eventId).pipe(
          map((response: HttpResponse<EventRegisterResponse>) =>
            PublicEventActions.registerForEventSuccess({ response: response.message })
          ),
          catchError((error: HttpError) => of(PublicEventActions.registerForEventFailure({ error })))
        )
      )
    );
  });
}
